// src/config/features.js
// Feature flags for conditional functionality
// CRITICAL: This file was missing from ZIP — required for build

export const CATEGORIES_ENABLED = true;
export const PREMIUM_SECTION_ENABLED = true;
export const FREE_SECTION_ENABLED = true;
export const COMMENTS_ENABLED = true;
export const SHARE_ENABLED = true;
export const DISCLAIMER_ENABLED = true;
export const SEARCH_SUGGESTIONS_ENABLED = true;
export const TRENDING_ENABLED = true;
export const ANALYTICS_ENABLED = true;
export const DARK_MODE_DEFAULT = true;